// extracted by mini-css-extract-plugin
export default {"Pagination":"Pagination_Pagination__pxTQk"};